<template>
  <button
    :class="[
      variant === 'primary'
        ? 'btn--primary'
        : variant === 'secondary'
        ? 'btn--secondary'
        : variant === 'white'
        ? 'btn--white'
        : variant === 'disableGray'
        ? 'btn--disableGray'
         : variant === 'transparent'
        ? 'btn--gPaySecondary'
        : variant === 'transparentPrimary'
        ?'btn--gPaySecondaryPrimary'
        : '',
      disabled || loading
        ? 'cursor-not-allowed pointer-events-none'
        : '',
      size === 'normal' ? 'btn--normal' : size === 'small' ? 'btn--small' : size === 'average' ? 'btn--average' : '',
    ]"
    @click="$emit('on-click')"
    class="btn"
    :type="type"
    :disabled="loading || disabled"
  >
    <slot></slot>
    <Vue3Lottie v-if="arrowAnimation" class="absolute right-6 m-0" :animationData="BtnArrow" :speed="1" :loop="true" :height="isMobile  ? 35 : 40" :width="isMobile ? 35 : 50"/>
  </button>
</template>
<script>
import BtnArrow from '../assets/animation/btn-arrow.json';

export default {
  name: 'custom-button',
  components: {
  },
  data() {
    return {
      BtnArrow,
      isMobile: false,
    };
  },
  mounted() {
    this.init();
  },
  props: {
    variant: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: 'submit',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    arrowAnimation: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: 'normal',
    },
  },
  methods: {
    init() {
      this.isMobile = window.innerWidth <= 768; // set the breakpoint for mobile devices
    },
  }
};
</script>
